import { render, staticRenderFns } from "./productsCard.vue?vue&type=template&id=672f34fe&scoped=true&"
import script from "./productsCard.vue?vue&type=script&lang=js&"
export * from "./productsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672f34fe",
  null
  
)

export default component.exports